<template>
<!-- 带筛选的多选组件 -->
    <div class="AreaSelectItemMain">
        <div class="searchBox">
            <el-input
                size="mini"
                class="zfyx-ipt"
                :placeholder="placeholder"
                v-model="key"
                clearable>
            </el-input>
        </div>
        <div class="listBox diyScrollBox innerScroll">
            <div class="zfyx-checkbox-group" v-if="showList && showList.length">
                <el-checkbox v-show="hasCheckAll" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <div :class="['listCheckItem',{'active':activeItem == item.sName}]" v-for="(item,index) in showList" :key="index">
                    <el-checkbox
                        :label="item.sName"
                        v-model="item.isChecked()"
                        :indeterminate="item.isIndeterminate()"
                        @change="checkMainNode($event,item)">
                    </el-checkbox>
                    <div class="labelShow" @click="clickItem(item)">
                        {{item.sName}}<i v-if="item.aChildren && item.aChildren.length" class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>
            <p class="zfyx-nodata-txt" v-else>无匹配数据</p>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        // 搜索框提示文字
        placeholder:{
            default:'请搜索'
        },
        // 选项列表
        options:{
            type:Array,
            default:()=>[]
        },
        //当前active选项
        activeItem:{
            default:''
        },
        //是否有全选
        hasCheckAll:{
            default:false
        },
        
    },
    data() {
        return {
            key:'',//搜索关键字
            isIndeterminate:false,
            checkAll:false,
        }
    },
    watch:{
        options:{
            handler(val){
                this.setCheckAllStatus()
            },
            deep:true
        }
    },
    computed:{
        showList(){
            let list = this.options.filter(item=>item.sName.indexOf(this.key) != -1)
            if(list && list.length == 0){
                this.$emit('clickItem',{})
            }
            return list
        }
    },
    created(){
        this.setCheckAllStatus()
    },
    methods: {
        // 点击item
        clickItem(item){
            // console.log(item);
            if(item.aChildren && item.aChildren.length){
                this.$emit('clickItem',item)
            }else{
                this.checkMainNode(!item.checked,item)
            }
        },
        checkMainNode(val,node) {
            node.setChecked(val);
            this.$emit("valueChange");
        },
        handleCheckAllChange(val){
            this.options.forEach(item=>{
                this.checkMainNode(val,item)
            })
            // this.isIndeterminate = false;
        },
        setCheckAllStatus(){
            let checkedArr = this.options.filter(item=>item.isChecked())
            if(checkedArr.length){
                const n = checkedArr.length,
                      m =this.options.length;
                if(m == n){
                    const indeterminatLength = this.options.filter(item=>item.isIndeterminate()).length;
                    if(indeterminatLength){
                        this.checkAll = false
                        this.isIndeterminate = true
                    }else{
                        this.checkAll = true
                        this.isIndeterminate = false
                    }

                }else{
                    this.checkAll = false
                    this.isIndeterminate = true
                }
            }else{
                this.checkAll = false
                this.isIndeterminate = false
            }
        }
    },

}
</script>

<style lang="scss">
.AreaSelectItemMain{
    padding: 0.1rem 0.15rem;
    border-right: 1px solid #EEEEEE;
    min-width: 1.4rem;
    &:last-child{ border-right: none;}

    position: relative;
    .searchBox{
        position: absolute;
        left: 0.1rem;
        right: 0.1rem;
        .zfyx-ipt{
            .el-input__inner{
                box-shadow: none;
            }
        }
    }
    .listBox{
        margin-top: 0.35rem;
        max-height: 1.5rem;
        .zfyx-checkbox-group{
            display: flex;
            flex-direction: column;
            .el-checkbox{
                margin-right: 0;
                height: 0.3rem;
                line-height: 0.3rem;
                .el-checkbox__label{
                    width: calc(100% - 0.14rem);
                    position: relative;
                    i{
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        color: #9B9B9B;
                    }
                }
            }

            .listCheckItem{
                display: flex;
                align-items: center;
                font-size: 0.12rem;
                cursor: pointer;
                .el-checkbox{
                    .el-checkbox__label{
                        display: none;
                    }
                }

                .labelShow{
                    padding-left: 0.1rem;
                    width: calc(100% - 0.14rem);
                    position: relative;
                    i{
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        color: #9B9B9B;
                    }
                }

                &.active{
                    .labelShow{
                        color: #0091FF;
                        font-weight: bold;
                        i{
                            color: #0091FF;
                        }
                    }
                }
            }
        }
    }
}
</style>